import React from "react"
import ChatBox from "./ChatBox"  
export const AiAssistant = () => {
  return (
      <ChatBox />
  )
}